import React from "react";
import { Container } from "react-bootstrap";
import "./First.css";

const First = () => {
  return (
    <>
      <section className="first-webDevelopment-section">
        <Container>
          <div className="page-title text-center">
            <h1>Web Development</h1>
            <div className="sub-info">
              <p>Design and develop a beautiful websites as per your need.</p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
